import * as React from 'react';
import { Status } from './as-data-provider';
import { createAvailableProductsProvider } from './default-available-products-provider';
var _a = createAvailableProductsProvider(), fetchAvailableProducts = _a.fetchMethod, DefaultDataProviderComponent = _a.ProviderComponent;
var unresolvedAvailableProducts = {
    status: Status.LOADING,
    data: null,
};
export var AvailableProductsProvider = function (_a) {
    var isUserCentric = _a.isUserCentric, children = _a.children, availableProductsDataProvider = _a.availableProductsDataProvider;
    if (isUserCentric) {
        var CustomDataProviderComponent = availableProductsDataProvider &&
            availableProductsDataProvider.ProviderComponent;
        var DataProviderComponent = CustomDataProviderComponent || DefaultDataProviderComponent;
        return React.createElement(DataProviderComponent, null, children);
    }
    // We should never be reading from this provider in non-user-centric mode, so here I model it as a provider that never resolves.
    return (React.createElement(React.Fragment, null, children(unresolvedAvailableProducts)));
};
export var prefetchAvailableProducts = function (customProvider) {
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    fetchAvailableProducts({});
};
export var resetAvailableProducts = function (customProvider) {
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    fetchAvailableProducts.reset();
};
//# sourceMappingURL=products-data-provider.js.map